<template>
  <div class="i-contain">
    <div class="tel-sty flex-row">
      <img src="../assets/images/model-com/tx.png" alt="" />
      <p v-if="isLogin">{{ maskedMobile(mobileNo) }}</p>
      <p v-else @click="goLogin()">去登陆</p>
    </div>
    <div class="changebox" v-if="isLogin" @click="logout">退出登录</div>
    <div class="zw-box" v-if="isNavBar"></div>
    <van-nav-bar
      v-if="isNavBar"
      ref="navbar"
      custom-class="navbarcss"
      title="课程列表"
      fixed
    />
    <div class="top com-padding">
      <img :src="banner" class="imgSize-banner" alt="" />
      <div class="content">
        <van-tabs
          ref="tabs"
          v-model="active"
          :offset-top="navHeight"
          :sticky="tabSticky"
          @click="onClick"
        >
          <van-tab
            v-for="(i, index) in typeData"
            :key="index + 'a'"
            :title="i.prijectname"
          >
            <div class="body-y">
              <div
                class="card-box"
                v-for="(item, idx) in cardDataList"
                :key="idx + 'a'"
              >
                <LabelHeader :left="item.title" />
                <IndexCard
                  v-for="(child, subIdx) in item.array"
                  :key="subIdx + 'b'"
                  :cardData="child"
                />
              </div>

              <NullState v-if="nullState" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-dialog
      v-model="loginDialogShow"
      title="欢迎登录"
      confirmButtonColor="#2ACE9E"
      show-cancel-button
      @confirm="loginSumbit"
    >
      <div class="login-card">
        <div class="flex-direction-column yd-input-bigbox">
          <div class="input-box">
            <input
              type="text"
              class="inydtel"
              v-model="form.mobileNo"
              id="mobileNo"
              placeholder="请输入手机号码"
              clear
            />
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import IndexCard from "@/views/Index-components/IndexCard.vue";
import LabelHeader from "@/components/LabelHeader.vue";
import { getBxxyCourseApiList, bxxyCourseLoginApi } from "@/api/index";
import { mapState } from "vuex";
import { Dialog } from "vant";
export default {
  data() {
    return {
      active: 0,
      isNavBar: true,
      loginDialogShow: false,
      nullState: false,
      search: require("../assets/images/model-com/search.png"),
      banner: require("../assets/images/model-com/a1.png"),
      model1: require("../assets/images/model-com/a2.png"),
      model2: require("../assets/images/model-com/a3.png"),
      navHeight: 0,
      tabSticky: false,
      form: {},
      cardDataList: [],
      typeData: [
        {
          prijectname: "国学",
          code: "COURSE_BXXY_GX",
        },
        {
          prijectname: "科学",
          code: "COURSE_BXXY_KX",
        },
        {
          prijectname: "社会",
          code: "COURSE_BXXY_SH",
        },
        {
          prijectname: "动漫汉语",
          code: "COURSE_BXXY_DMHY",
        },
      ],
      navBarHeight: 0,
    };
  },
  computed: {
    ...mapState("new_user", ["isLogin", "mobileNo"]),
  },
  components: {
    LabelHeader,
    IndexCard,
  },
  created() {
    this.getNavBarHeight();
    this.getTypeList();
    // this.getOpenid();
  },
  mounted() {
    this.$store.dispatch("tabbar/sendAcive", 0);
    window.addEventListener("scroll", this.handleScroll, false); // 修改为 false
  },
  methods: {
    logout() {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定要退出登录吗？",
        confirmButtonColor: "#2ACE9E",
      })
        .then(() => {
          this.$store.dispatch("new_user/logout");
        })
        .catch(() => {
          // on cancel
        });
    },
    loginSumbit() {
      this.isPhoneNumberValid = this.form.mobileNo.length === 11;
      if (!this.isPhoneNumberValid) {
        return this.$toast.fail("请输入有效的手机号");
      }
      var reqData = {
        mobileNo: this.form.mobileNo,
      };
      bxxyCourseLoginApi(reqData).then((res) => {
        if (res.data.state === 0) {
          this.loginDialogShow = false;
          this.$toast.success("登录成功");
          var loginData = {
            mobileNo: this.form.mobileNo,
            isLogin: true,
          };
          console.log("loginData", loginData);

          this.$store.dispatch("new_user/login", loginData);
        } else {
          this.$store.dispatch("user/logout");
          this.$toast.fail("登录失败");
        }
      });
    },
    getOpenid() {
      if (this.openId === "") this.$store.dispatch("user/getOpenId");
    },
    goSearch() {
      this.$go("/search");
    },
    getNavBarHeight() {
      this.$nextTick(() => {
        const navbar = this.$refs.navbar.$el;
        if (navbar) {
          const height = navbar.getBoundingClientRect().height;
          this.navHeight = height;
          this.isNavBar = false;
        }
      });
    },
    // async getYaxTjList() {
    //   var reqData = {
    //     pageNum: 1,
    //     rownum: 20,
    //   };
    //   let res = await getYaxSuggestNewsList(reqData);
    //   if (res.data.state === 0) {
    //     this.cardDataList = res.data.data.newsList;
    //     console.log("this.cardDataList", this.cardDataList);
    //   } else {
    //     this.cardDataList = [];
    //   }
    // },
    async getTypeList(e) {
      var testCode = e || "COURSE_BXXY_GX";
      var reqData = {
        pageNum: 1,
        muLu: testCode,
        rownum: 20,
      };
      let res = await getBxxyCourseApiList(reqData);
      if (res.data.state === 0) {
        console.log(res.data.data);
        var cList = res.data.data;
        const grouped = cList.reduce((acc, item) => {
          const key = item.muLu; // 分组 key
          // 第一次遇到该目录，创建组
          if (!acc[key]) {
            acc[key] = {
              muLu: key,
              title: item.muLuName, // 目录名（未来有值也能自动带上）
              array: [],
            };
          }
          // 加入课程
          acc[key].array.push(item);

          return acc;
        }, {});
        const groupedArr = Object.values(grouped);
        if (testCode === "COURSE_BXXY_GX") {
          groupedArr.sort((a, b) => {
            if (a.title === "大班上") return -1;
            if (b.title === "大班上") return 1;
            return 0;
          });
        }
        if (testCode === "COURSE_BXXY_KX") {
          const orderMap = {
            大班: 1,
            中班: 2,
            小班: 3,
          };
          groupedArr.sort((a, b) => {
            const oa = orderMap[a.title] || 999; // 如果有新分类，放到最后
            const ob = orderMap[b.title] || 999;
            return oa - ob;
          });
        }
        this.cardDataList = groupedArr;

        this.nullState = false;
      } else {
        this.cardDataList = [];
        this.nullState = true;
      }
    },
    goLogin() {
      this.loginDialogShow = true;
    },
    onClick(newsName, index) {
      console.log("onClick", newsName, index);
      var code = this.typeData[newsName].code;
      this.cardDataList = [];
      this.getTypeList(code);
    },
    goAjModel() {
      this.$go("/aj/index");
    },
    goAYModel() {
      this.$toast({
        message: "功能待开发",
        duration: 3000,
      });
    },
    maskedMobile(e) {
      const num = e || "";
      if (num.length < 7) return num; // 太短就不处理
      return num.substring(0, 3) + "****" + num.substring(7);
    },
    handleScroll() {
      // const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const tabs = this.$refs.tabs;
      const topDistance = tabs.$el.getBoundingClientRect().top;
      if (topDistance < this.navHeight) {
        this.isNavBar = true;
        this.tabSticky = true;
        this.$refs.tabs.resize();
      } else {
        this.isNavBar = false;
        this.tabSticky = false;
        this.$refs.tabs.resize();
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.zw-box {
  width: 100%;
  position: fixed;
  top: 0;
  height: 60px;
  background-color: white;
  z-index: 1;
}
.i-contain {
  width: 100%;
  min-height: 100vh;
  background: #f7f8f9;
  position: relative;
  overflow: auto;
  z-index: 0;
}
.com-padding {
  padding: 0 10px;
  box-sizing: border-box;
}
.i-contain::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background: linear-gradient(
    180deg,
    #88e7dd 0%,
    rgba(102, 218, 197, 0.04) 100%
  );
  width: 100%;
  height: 245px;
}
.imgSize-search {
  width: 100%;
  height: 42px;
  margin-top: 82px;
}
.imgSize-banner {
  width: 100%;
  height: 166px;
}
.imgSize-model-box {
  width: 100%;
  justify-content: space-between;
  margin-top: 21px;
  gap: 10px;
  img {
    width: 165px;
    box-sizing: border-box; /* 确保padding和border不会影响宽度计算 */
  }
}
.content {
  margin-top: 15px;
  border-radius: 6px;
}
/deep/.van-tabs__line {
  background: linear-gradient(123.32deg, #60ebc6 0%, #29cd9d 73.67%);
}
.body-y {
  width: 100%;
  background-color: white;
  min-height: 300px;
  padding: 15px;
  box-sizing: border-box;
}
.tel-sty {
  color: white;
  font-size: 16px;
  padding: 10px 20px 10px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.card-box {
  border-radius: 15px;
  border: #29cd9d 1px solid;
  padding: 10px 0;
  box-sizing: border-box;
}
.card-box:nth-child(n + 2) {
  margin-top: 10px;
}
/deep/.van-tab__text {
  font-weight: 600;
}

.login-card {
  width: 100%;
  padding: 19px 26px 40px 26px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 21px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .c-title {
    font-weight: bold;
    font-size: 21px;
    color: #333333;
    line-height: 24px;
    text-align: center;
  }
}

.input-box {
  width: 100%;
  height: 52px;
  background: #f2f4f5;
  border-radius: 26px;
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.input-box2 {
  width: 100%;
  background: #f2f4f5;
  display: flex;
  align-items: center;
  border-radius: 26px;
  transition: opacity 0.8s ease;
  /* 过渡效果的属性和持续时间 */
  opacity: 0;
  height: 0;
  /* 初始状态高度为0，不占用位置 */
  overflow: hidden;
  /* 隐藏超出高度的内容 */
  /* 初始状态为隐藏 */
}
.inydtel {
  width: 100%;
  height: 60px;
  margin-left: 20px;
}
.changebox {
  padding: 5px 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 100px 0px 0px 100px;
  border: 1px solid #ff7b26;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
  color: #ff7b26;
  position: absolute;
  right: 0px;
  top: 10px;
  z-index: 5;
}
</style>
